import * as React from 'react';
import styled from 'styled-components';
import theme from 'theme';
import { Modal } from 'antd';
import { cutText, newsSourceMap } from 'utils';
import { formatDate } from 'utils/formatting';
import ArticleModalContent from './ArticleModalContent';
import { ArticleListType } from 'components/common/FeedTypes';
import { FeedItem } from 'components/context/types';
import t from 'utils/translations';
import { ArticleModalElement } from 'components/common/ArticleModalElement';

const Title = styled.h4`
    margin: 0 0 5px;
    font-family: ${theme.fonts.regular};
    color: ${theme.colors.main};
`;

const Li = styled.li`
    border-bottom: 1px solid ${theme.colors.gray_lightest};
    padding: 10px 0 5px;

    &:hover ${Title} {
        text-decoration: underline;
    }

    &:first-of-type {
        padding: 0 0 5px;
    }

    &:last-of-type {
        border-bottom: none;
    }
`;

const Source = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${theme.colors.gray_dark};
    font-size: 12px;
    p {
        margin: 0;
    }
`;

type ListItemProps = FeedItem & {
    articleListType: ArticleListType;
};

const modalContentShouldBeFetchedFromApi = (
    articleListType: ArticleListType
) => {
    return (
        articleListType === ArticleListType.TALENTNEWS ||
        articleListType === ArticleListType.APPOINTMENT
    );
};

export default function ArticleListItem({
    id,
    title,
    published,
    source,
    content,
    articleListType,
    uri,
    companyIds,
    modified
}: ListItemProps) {
    const [modalVisible, setModalVisible] = React.useState(false);

    const publishedFormatted = formatDate(published);
    const modifiedFormatted = formatDate(modified);
    const closeModal = () => setModalVisible(false);
    const openArticle = () => {
        setModalVisible(true);
    };

    let shownTitle;
    switch (articleListType) {
        case ArticleListType.SOCIALMEDIA:
            shownTitle = content ? cutText(`${title}: ${content}`, 75) : title;
            break;
        case ArticleListType.APPOINTMENT:
            shownTitle = `${t('APPOINTMENT_NEWS')}: ${title}`;
            break;
        default:
            shownTitle = title;
    }

    return (
        <Li>
            <a onClick={openArticle}>
                <Title>{shownTitle}</Title>
                <Source>
                    <p>{newsSourceMap(source || '')}</p>
                    <p>{`${t('PUBLISHED')} ${publishedFormatted}`}</p>
                    <p>
                        {modifiedFormatted !== '' &&
                            `${t('MODIFIED')} ${modifiedFormatted}`}
                    </p>
                </Source>
            </a>
            <Modal
                visible={modalVisible}
                onCancel={closeModal}
                footer={null}
                width={600}
                destroyOnClose={true}
            >
                {modalContentShouldBeFetchedFromApi(articleListType) ? (
                    <ArticleModalContent id={id || ''} source={source || ''} />
                ) : (
                    <ArticleModalElement
                        title={title || ''}
                        uri={uri || ''}
                        published={publishedFormatted}
                        businessIds={companyIds || []}
                        content={content || ''}
                        source={source || ''}
                        modified={modifiedFormatted}
                    />
                )}
            </Modal>
        </Li>
    );
}
